import { Box, Button, CloseButton, Drawer, DrawerBody, DrawerContent, DrawerOverlay, Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import FilterList from '@/assets/icons/ic-filter-list.svg';

import { SpeakersFilter } from '@/components/ui/features/speakers/SpeakersFilter/SpeakersFilter';
import { StringParam, useQueryParams } from '@/hooks/useQueryParams';

export const SpeakersFilterDrawer = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const { query, change } = useQueryParams<{ event_id: string; query: string }>({
    event_id: StringParam,
    query: StringParam,
  });

  function reset() {
    change({ event_id: null, query }, { method: 'replace', shallow: true });
  }

  return (
    <Drawer isOpen={isOpen} placement="left" onClose={onClose} size="md">
      <DrawerOverlay />
      <DrawerContent p={{ base: 5, md: 10 }}>
        <Flex mb={{ base: 5, md: 10 }} alignItems="center" justifyContent="space-between">
          <Button
            variant="unstyled"
            rightIcon={
              <Box color="violet.500">
                <FilterList />
              </Box>
            }
            onClick={reset}
          >
            {t('library.clearFilters')}
          </Button>
          <CloseButton onClick={onClose} />
        </Flex>

        <DrawerBody p={0}>
          <SpeakersFilter />
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};
